import React from 'react';
import { classNames } from '../../utils/style';
import { fontBody, fontHeading2 } from '../../styles/typographyNew';

export interface BlockHeaderProps {
  title?: string;
  subtitle?: string;
  headingAlignment?: 'left' | 'center' | 'right';
}

/**
 * A reusable header component for blocks that displays a title and optional subtitle
 * with configurable alignment.
 *
 * @example
 * ```tsx
 * <BlockHeader
 *   title="Customer Testimonials"
 *   subtitle="What our clients say about us"
 *   headingAlignment="center"
 * />
 * ```
 */

export const BlockHeader = ({
  title,
  subtitle,
  headingAlignment = 'left',
}: BlockHeaderProps) => {
  const alignmentClasses = {
    left: 'mr-auto text-left',
    center: 'mx-auto text-center',
    right: 'ml-auto text-right',
  }[headingAlignment];

  return (
    (title || subtitle) && (
      <div
        className={classNames(
          'BlockHeader',
          'flex max-w-[819px] flex-col gap-8',
          alignmentClasses,
        )}
      >
        {title && (
          <h2 className={classNames(fontHeading2, 'text-default-title')}>
            {title}
          </h2>
        )}
        {subtitle && (
          <p className={classNames(fontBody, 'text-default-content')}>
            {subtitle}
          </p>
        )}
      </div>
    )
  );
};
